"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchChatInfo = void 0;
const react_1 = require("react");
const context_1 = require("../context");
const useFetchChatInfo = () => {
    const { setChat } = (0, react_1.useContext)(context_1.ChatInfoContext);
    const { selectedOrgUser } = (0, react_1.useContext)(context_1.OrganizationContext);
    const setChatInfoContext = (chatId, groupType) => __awaiter(void 0, void 0, void 0, function* () {
        if (chatId) {
            if (selectedOrgUser) {
                const chatManager = selectedOrgUser.chatManager.getChatManagerForGroupType(groupType);
                if (chatManager) {
                    chatManager.getStoredChat(chatId);
                    setChat(chatManager.touchChat(chatId));
                    yield chatManager.getFreshChat(chatId);
                    setChat(chatManager.getChat(chatId));
                }
            }
        }
        else {
            setChat(undefined);
        }
    });
    return { setChatInfoContext };
};
exports.useFetchChatInfo = useFetchChatInfo;
